import React, {Component} from 'react';

import { Carousel } from '../../../shared/components/carousel';
import NavArrow from '../../../shared/components/nav-arrow';
import ContentCarouselCard from './content-carousel-card';
import withWindowResize from '../../../ui/components/window-resize';


class ContentCarousel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      relatedBlogs: [],
    }
  }



  static getDerivedStateFromProps(nextProps, prevState) {

    if(typeof nextProps.relatedBlogs === "object" && Object.keys(nextProps.relatedBlogs).length) {
      const {hits} = nextProps.relatedBlogs.hits;
      const relatedBlogs = hits.reduce((acc, hit) => {
        const {blogThumbnail, blogTitle, vanityUrl} = hit["_source"];
        const blog = {blogThumbnail, blogTitle, vanityUrl};
        acc.push(blog);
        return acc;
      }, []);

      return {
        relatedBlogs,
      }

    }

    return null;
  }

  getXSellSettings = (device) => {
    return {
        slidesToShow: device === 'desktop' ? 5 : 1,
        slidesToScroll: 1,
        ...this.controls(),
      }
  }


  controls = () => {
    return {
        renderCenterLeftControls : NavArrow.PrevArrow,
        renderCenterRightControls: NavArrow.NextArrow,
        renderBottomCenterControls: null,
    }
  }

  render() {

    const {relatedBlogs} = this.state;
    const {header=null, device} = this.props;
 
    return (
      <div className="content-carousel-container">
      {
        header && <h3>{header}</h3>
      }
      <div className={`content-carousel-${device}-component`}>
        {
            <Carousel renderBottomCenterControls={false} id='content-carousel-richtext' className='content-carousel-richtext' {...this.getXSellSettings(device)} ref={carousel=> carousel = carousel}>
              {
                relatedBlogs.map((relatedBlog, i) => {
                  const {blogThumbnail, blogTitle, vanityUrl} = relatedBlog;
                  return (
                    <ContentCarouselCard thumbnail={blogThumbnail} title={blogTitle} vanityUrl={vanityUrl} key={i}/>
                  )
                })
              }
            </Carousel>
        }
        </div>
      </div>
    );
  }
}

export default withWindowResize(ContentCarousel);
